import { render, staticRenderFns } from "./thirdCert_page.vue?vue&type=template&id=071a9ebf&scoped=true"
import script from "./thirdCert_page.vue?vue&type=script&lang=js"
export * from "./thirdCert_page.vue?vue&type=script&lang=js"
import style0 from "./thirdCert_page.vue?vue&type=style&index=0&id=071a9ebf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071a9ebf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('071a9ebf')) {
      api.createRecord('071a9ebf', component.options)
    } else {
      api.reload('071a9ebf', component.options)
    }
    module.hot.accept("./thirdCert_page.vue?vue&type=template&id=071a9ebf&scoped=true", function () {
      api.rerender('071a9ebf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/thirdCert_page.vue"
export default component.exports